// Traductions des types d'éléments
export const ELEMENT_TYPE_LABELS = {
  text: 'Texte',
  richtext: 'Texte enrichi',
  image: 'Image',
  profilephoto: 'Photo de profil',
  orglogo: 'Logo organisation',
  banner: 'Bannière',
  button: 'Bouton',
  icontext: 'Icône + Texte',
  divider: 'Séparateur',
  spacer: 'Espace',
  social: 'Réseau social',
  socialgroup: 'Groupe de réseaux sociaux',
  qrcode: 'QR Code'
};

// Fonction pour obtenir le label traduit d'un type d'élément
export const getElementTypeLabel = (type) => {
  return ELEMENT_TYPE_LABELS[type] || type;
};
